import { createSelector } from 'reselect';
import { FileMetadata } from '../../types/media-assets';
import { StringMap } from '../../types/system';
import { FilesRootState } from './files-root.reducer';
import { getFilesRoot } from './files.selectors';
import { MetadataLoadingState } from './metadata.reducer';

export const getFileMetadataMap = createSelector(
  getFilesRoot,
  (state: FilesRootState): StringMap<FileMetadata> => state.metadata.map,
);

export const getMetadataLoadingStateMap = createSelector(
  getFilesRoot,
  (mediaAssets: FilesRootState): StringMap<MetadataLoadingState> =>
    mediaAssets.metadata.loadingState,
);
